import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  Stack,
} from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import Breadcrumb from './BreadCrump';
import TopNav from './Navbar';
import LeftNavbar from './LeftNav';

const CreateEvent = () => {
  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('http://196.216.9.34:5020/api/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ title, date, description }),
      });
      if (res.ok) {
        alert('Event created successfully!');
        setTitle('');
        setDate('');
        setDescription('');
      } else {
        console.error('Failed to create event');
      }
    } catch (err) {
      console.error('Error creating event:', err);
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <LeftNavbar />

      <Box sx={{ flexGrow: 1, ml: { lg: '240px' } }}>
        <TopNav />
        <Box sx={{ p: 10, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
          <Breadcrumb currentPage="Create Event" />

          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ color: '#ff6600', mb: 4 }}
          >
            <EventIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Create Event
          </Typography>

          <Card sx={{ boxShadow: 3 }}>
            <CardContent>
              <form onSubmit={handleSubmit}>
                <Stack spacing={3}>
                  <TextField
                    label="Title"
                    variant="outlined"
                    fullWidth
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />

                  <TextField
                    label="Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    required
                  />

                  <TextField
                    label="Description"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={4}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                  />

                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ bgcolor: '#ff6600', '&:hover': { bgcolor: '#e65c00' } }}
                  >
                    Publish Event
                  </Button>
                </Stack>
              </form>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

export default CreateEvent;
